import { produce } from 'immer';
import { CONFIG_SUCCESS } from '../actions/config';
const defaultState = {};
const resources = produce((state, action) => {
  switch (action.type) {
    case CONFIG_SUCCESS:
      {
        const resources = action.payload.resources || [];
        resources.map(resource => {
          state[resource.name] = resource;
        });
        return state;
      }
    default:
      return state;
  }
}, defaultState);
export default resources;